import { Injectable, ApplicationRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChangeLanguageService {
  private languageSubject = new BehaviorSubject<string>('es');
  currentLanguage$ = this.languageSubject.asObservable();

  constructor(
    private translate: TranslateService,
    private appRef: ApplicationRef // Use ApplicationRef for global change detection
  ) {
    const savedLang = localStorage.getItem('selectedLanguageCode') || 'es';
    this.translate.use(savedLang);
    this.languageSubject.next(savedLang);
  }

  changeLanguage(code: string) {
    localStorage.setItem('selectedLanguageCode', code);
    this.translate.use(code);
    this.languageSubject.next(code);

    // Trigger global change detection
    this.appRef.tick();
  }

  getCurrentLanguage(): string {
    return this.languageSubject.value;
  }
}
